import { render, staticRenderFns } from "./createServiceModal.vue?vue&type=template&id=647a3e4d&"
import script from "./createServiceModal.vue?vue&type=script&lang=js&"
export * from "./createServiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647a3e4d')) {
      api.createRecord('647a3e4d', component.options)
    } else {
      api.reload('647a3e4d', component.options)
    }
    module.hot.accept("./createServiceModal.vue?vue&type=template&id=647a3e4d&", function () {
      api.rerender('647a3e4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/createServiceModal.vue"
export default component.exports